export enum KeyboardKey {
  ArrowDown = 'ArrowDown',
  ArrowUp = 'ArrowUp',
  Backspace = 'Backspace',
  Enter = 'Enter',
  Spacebar = ' ',
  Tab = 'Tab',
}
